import { createContext, useContext } from 'react';

// The assistant panel: whether it is open, how wide, which conversation, the
// reply being streamed, and what the current page adds to the screen context. Provided above the routes so all of it outlives a
// page change — a reply keeps streaming while the user moves around the app.
const AgentPanelContext = createContext(null);

export const useAgentPanelContext = () => useContext(AgentPanelContext);

// Summaries of the records a conversation links, keyed by `refKey`, so a chip
// or card deep inside rendered Markdown can label itself without the
// summaries being threaded through every component in between.
export const AgentRefsContext = createContext({});

export const useAgentRefs = () => useContext(AgentRefsContext);

export default AgentPanelContext;
